var _rect, _rect2, _rect3, _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.25,
    y: 1.75,
    width: 17.5,
    height: 17.5,
    rx: 6,
    fill: "url(#paint0_radial_412_93291)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.25,
    y: 1.75,
    width: 17.5,
    height: 17.5,
    rx: 6,
    fill: "url(#paint1_radial_412_93291)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1.25,
    y: 1.75,
    width: 17.5,
    height: 17.5,
    rx: 6,
    fill: "url(#paint2_radial_412_93291)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.375 7.0625C14.375 7.58027 13.9553 8 13.4375 8C12.9197 8 12.5 7.58027 12.5 7.0625C12.5 6.54473 12.9197 6.125 13.4375 6.125C13.9553 6.125 14.375 6.54473 14.375 7.0625Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 13.625C11.7259 13.625 13.125 12.2259 13.125 10.5C13.125 8.77411 11.7259 7.375 10 7.375C8.27411 7.375 6.875 8.77411 6.875 10.5C6.875 12.2259 8.27411 13.625 10 13.625ZM10 12.375C11.0355 12.375 11.875 11.5355 11.875 10.5C11.875 9.46447 11.0355 8.625 10 8.625C8.96447 8.625 8.125 9.46447 8.125 10.5C8.125 11.5355 8.96447 12.375 10 12.375Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.75 10.25C3.75 8.1498 3.75 7.0997 4.15873 6.29754C4.51825 5.59193 5.09193 5.01825 5.79754 4.65873C6.5997 4.25 7.6498 4.25 9.75 4.25H10.25C12.3502 4.25 13.4003 4.25 14.2025 4.65873C14.9081 5.01825 15.4817 5.59193 15.8413 6.29754C16.25 7.0997 16.25 8.1498 16.25 10.25V10.75C16.25 12.8502 16.25 13.9003 15.8413 14.7025C15.4817 15.4081 14.9081 15.9817 14.2025 16.3413C13.4003 16.75 12.3502 16.75 10.25 16.75H9.75C7.6498 16.75 6.5997 16.75 5.79754 16.3413C5.09193 15.9817 4.51825 15.4081 4.15873 14.7025C3.75 13.9003 3.75 12.8502 3.75 10.75V10.25ZM9.75 5.5H10.25C11.3207 5.5 12.0486 5.50097 12.6112 5.54694C13.1592 5.59171 13.4395 5.67287 13.635 5.77248C14.1054 6.01217 14.4878 6.39462 14.7275 6.86502C14.8271 7.06052 14.9083 7.34078 14.9531 7.8888C14.999 8.45141 15 9.17928 15 10.25V10.75C15 11.8207 14.999 12.5486 14.9531 13.1112C14.9083 13.6592 14.8271 13.9395 14.7275 14.135C14.4878 14.6054 14.1054 14.9878 13.635 15.2275C13.4395 15.3271 13.1592 15.4083 12.6112 15.4531C12.0486 15.499 11.3207 15.5 10.25 15.5H9.75C8.67928 15.5 7.95141 15.499 7.3888 15.4531C6.84078 15.4083 6.56052 15.3271 6.36502 15.2275C5.89462 14.9878 5.51217 14.6054 5.27248 14.135C5.17287 13.9395 5.09171 13.6592 5.04694 13.1112C5.00097 12.5486 5 11.8207 5 10.75V10.25C5 9.17928 5.00097 8.45141 5.04694 7.8888C5.09171 7.34078 5.17287 7.06052 5.27248 6.86502C5.51217 6.39462 5.89462 6.01217 6.36502 5.77248C6.56052 5.67287 6.84078 5.59171 7.3888 5.54694C7.95141 5.50097 8.67928 5.5 9.75 5.5Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_412_93291",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.5 14.875) rotate(-55.3758) scale(15.9498)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B13589"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79309,
    stopColor: "#C62F94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A3AC8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_412_93291",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.875 19.875) rotate(-65.1363) scale(14.1214)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0E8B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.444662,
    stopColor: "#FB8A2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71474,
    stopColor: "#E2425C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2425C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_412_93291",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.312501 2.375) rotate(-8.1301) scale(24.3068 5.19897)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.156701,
    stopColor: "#406ADC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.467799,
    stopColor: "#6A45BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A45BE",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.90427586f8e6b362ef222d3afaafb161.svg";
export { ForwardRef as ReactComponent };